import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcShellNavigate, RpcShellNavigateKey, RpcShellNavigateResult } from './rpc-shell-navigate-model';

export class RpcShellNavigateClient {
    /**
     * The shell navigate command.
     *
     * @param data the shell naviage object.
     * @return Promise<RpcShellNavigateResult> the promise object of shell navigate result.
     */
    public static shellNavigate(rpc: Rpc, data: RpcShellNavigate): Promise<RpcShellNavigateResult> {
        return RpcInboundClient.call(rpc, RpcShellNavigateKey.command, RpcShellNavigateKey.version, data);
    }
}
